export default __webpack_public_path__ + "static/cf-network-map-9415b7a21f7a2ee569813eae1f6e2483.png";